module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-hd-main-btn">\r\n    '+
((__t=(UTILS.getSVGIcon('cercle_plein_trois_points','button')))==null?'':__t)+
'\r\n    <ul style="position: fixed;" class="c-panneauMenu phx-grid-vues-chooser">\r\n    </ul>\r\n</div>';
}
return __p;
};
